module.exports = __webpack_public_path__ + "img/movie-cinema_active.b7a84838.png";